import { render, staticRenderFns } from "./topArticleBoxSp.vue?vue&type=template&id=0bb3a193&"
import script from "./topArticleBoxSp.vue?vue&type=script&lang=js&"
export * from "./topArticleBoxSp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports